import { ICompany } from 'src/interfaces';
import { AuthActionType } from '../action-types';
import { AuthAction } from '../actions';

interface AuthState {
  loading: boolean;
  error: string | null;
  data: { accessToken: string; permissions: []; companies: ICompany[] } | null;
}

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const reducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case AuthActionType.SIGNIN:
      return { loading: true, error: null, data: null };
    case AuthActionType.SIGNIN_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case AuthActionType.SIGNIN_FAILURE:
      return { loading: false, error: action.payload, data: null };
    default:
      return state;
  }
};

export default reducer;
